export const Config = {
  app_api_url: window.brochure_app_api_url ? window.brochure_app_api_url : "https://prospekte.preispirat.ch",
  app_url: window.brochure_app_url ? window.brochure_app_url : "https://www.preispirat.ch",
  profital_url: "https://www.profital.ch",
  brochure_route: window.brochure_route ? window.brochure_route : "/brochures",
};

export const TrackingType = {
  BROCHURE_IMPRESSION: "BROCHURE_IMPRESSION",
  BROCHURE_CLICK: "BROCHURE_CLICK",
  BROCHUREPAGE_VIEW: "BROCHUREPAGE_VIEW",
  BROCHUREPAGE_CLICKOUT: "BROCHUREPAGE_CLICKOUT",
  BROCHUREPAGE_DURATION: "BROCHUREPAGE_DURATION",
  SCREEN_VIEW: "SCREEN_VIEW",
};

export const EventId = {
  SHOW_OFFER_CARD: "brochure.show",
  SHOW_NEXT_CARD: "next.brochure.show",
  SHOW_SIMILAR_CARD: "similar.brochure.show",
  NEXT_SLIDE: "brochure.nextpagebottom.click",
  PREVIOUS_SLIDE: "brochure.previouspagebottom.click",
  LAST_SLIDE: "brochure.lastpagebottom.click",
  OUT_LINK_CLICK: "brochure.outlink.click",
};

export const currURL = window.location.href;
